import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Card, Dropdown } from "react-bootstrap";
import LocationAutocomplete from "../LocationAutocomplete";
import { useLocation } from "react-router-dom";
import { FaPlus, FaTrash } from "react-icons/fa";
import { useTranslation } from "react-i18next";


const CustomTimeSelect = ({ value, onChange, options, error, placeholder }) => {
  return (
    <Dropdown className="flex-grow-1" style={{ minWidth: "75px" }}>
      <Dropdown.Toggle
        as="button"
        className={`form-select input-elegant px-2 py-2 d-flex justify-content-between align-items-center w-100 ${error ? "is-invalid" : ""}`}
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid var(--dark-border, #e2e8f0)",
          color: "var(--text-dark, #0f172a)",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "15px",
        }}
      >
        {value || placeholder}
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          maxHeight: "300px",
          overflowY: "auto",
          backgroundColor: "#ffffff",
          border: "1px solid var(--dark-border, #e2e8f0)",
          borderRadius: "8px",
          minWidth: "100%",
          padding: 0,
          boxShadow: "var(--shadow-md)",
        }}
      >
        {options.map((opt) => (
          <Dropdown.Item
            key={opt}
            onClick={() => onChange(opt)}
            style={{
              padding: "8px 16px",
              color: value === opt ? "var(--orange-primary, #ff6b00)" : "var(--text-dark, #0f172a)",
              backgroundColor: value === opt ? "var(--orange-light, #ffefe5)" : "transparent",
            }}
            className="custom-dropdown-item"
          >
            {opt}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const TimeSelect = ({ value, onChange, error, minTime = 0, maxTime = 23 }) => {
  const h24 = value ? value.split(":")[0].padStart(2, "0") : "";
  const m = value ? value.split(":")[1].padStart(2, "0") : "";

  const handleHourChange = (newHour) => {
    onChange(`${newHour}:${m || "00"}`);
  };

  const handleMinuteChange = (newMinute) => {
    const finalHour = h24 === "" ? "08" : h24;
    onChange(`${finalHour}:${newMinute}`);
  };

  const hourOptions = [...Array(24).keys()]
    .filter((hr) => hr >= minTime && hr <= maxTime)
    .map((hr) => hr.toString().padStart(2, "0"));
  const minuteOptions = ["00", "15", "30", "45"];

  return (
    <div className="d-flex gap-1 align-items-center">
      <CustomTimeSelect
        value={h24}
        onChange={handleHourChange}
        options={hourOptions}
        error={error}
        placeholder="--"
      />
      <span className="fw-bold text-dark">:</span>
      <CustomTimeSelect
        value={m}
        onChange={handleMinuteChange}
        options={minuteOptions}
        error={error}
        placeholder="--"
      />
    </div>
  );
};

const emptyDelivery = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const defaultDate = tomorrow.toISOString().split("T")[0];
  return {
    companyName: "",
    firstName: "",
    lastName: "",
    street: "",
    addressExtra: "",
    postalCity: "",
    postalCity_lat: "",
    postalCity_lng: "",
    phone: "",
    deliveryReference: "",
    deliveryDate: defaultDate,
    // timeFrom: "08:00",
    // timeTo: "08:00",
  };
};

const parseDurationMinutes = (durationText) => {
  if (!durationText) return 0;

  const text = String(durationText).toLowerCase();
  const hours = Number(text.match(/(\d+)\s*(?:hours?|hrs?)/)?.[1] || 0);
  const minutes = Number(text.match(/(\d+)\s*(?:minutes?|mins?)/)?.[1] || 0);

  return hours * 60 + minutes;
};

const formatLocalDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")}`;

const moveToNextWorkingMorning = (date) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + 1);
  nextDate.setHours(7, 0, 0, 0);
  while (nextDate.getDay() === 0) {
    nextDate.setDate(nextDate.getDate() + 1);
  }
  return nextDate;
};

function AddressFormDelivery({
  data,
  onChange,
  index,
  validationErrors = {},
  pickupForms,
  durationText,
}) {
  const location = useLocation();
  const { state } = location;
  const { t } = useTranslation();

  const previousDeliveryAddress =
    state?.formData?.zustellung?.[index]?.address || "";

  const [minDate, setMinDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [minTime, setMinTime] = useState("00:00");

  // useEffect(() => {
  //   const firstPickup = pickupForms?.[0];
  //   if (!firstPickup?.pickupDate || !firstPickup.timeTo) return;

  //   const [pickupHour, pickupMinute] = firstPickup.timeTo
  //     .split(":")
  //     .map(Number);
  //   let earliestDelivery = new Date(
  //     `${firstPickup.pickupDate}T${String(pickupHour).padStart(2, "0")}:${String(
  //       pickupMinute,
  //     ).padStart(2, "0")}:00`,
  //   );
  //   earliestDelivery.setMinutes(
  //     earliestDelivery.getMinutes() + parseDurationMinutes(durationText),
  //   );

  //   if (earliestDelivery.getHours() >= 18) {
  //     earliestDelivery = moveToNextWorkingMorning(earliestDelivery);
  //   } else if (earliestDelivery.getHours() < 7 || earliestDelivery.getDay() === 0) {
  //     earliestDelivery.setHours(7, 0, 0, 0);
  //     while (earliestDelivery.getDay() === 0) {
  //       earliestDelivery = moveToNextWorkingMorning(earliestDelivery);
  //     }
  //   }

  //   if (earliestDelivery.getTime() > 0) {
  //     setMinDate(formatLocalDate(earliestDelivery));
  //     setMinTime(
  //       `${String(earliestDelivery.getHours()).padStart(2, "0")}:${String(
  //         earliestDelivery.getMinutes(),
  //       ).padStart(2, "0")}`,
  //     );
  //   }
  // }, [pickupForms, durationText]);

  useEffect(() => {
    if (!data.deliveryDate || data.deliveryDate < minDate) {
      onChange("deliveryDate", minDate);
    }
    if (
      (!data.timeFrom || data.timeFrom < minTime) &&
      data.deliveryDate === minDate
    ) {
      onChange("timeFrom", minTime);
    }
  }, [minDate, minTime, data.deliveryDate, data.timeFrom, onChange]);

  const handleLocationChange = (e) => {
    const value = e?.target?.value || e?.value || "";
    const lat = e?.lat;
    const lng = e?.lng;

    const finalValue = value || previousDeliveryAddress;

    onChange("postalCity", finalValue);
    if (lat) onChange("postalCity_lat", lat);
    if (lng) onChange("postalCity_lng", lng);
  };

  useEffect(() => {
    if (previousDeliveryAddress && !data.postalCity) {
      onChange("postalCity", previousDeliveryAddress);
    }
  }, [previousDeliveryAddress, data.postalCity, onChange]);

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    onChange("deliveryDate", selectedDate);
    if (selectedDate === minDate && data.timeFrom < minTime) {
      onChange("timeFrom", minTime);
    }
  };

  const handleTimeFromChange = (e) => {
    const selectedTime = e.target.value;
    if (data.deliveryDate === minDate && selectedTime < minTime) {
      return;
    }
    onChange("timeFrom", selectedTime);
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="fw-bold with-icon">
          {t("company_name")}
        </Form.Label>
        <Form.Control
          type="text"
          value={data.companyName}
          onChange={(e) => onChange("companyName", e.target.value)}
          className="input-elegant"
        />
      </Form.Group>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">
            {t("first_name")} *
          </Form.Label>
          <Form.Control
            type="text"
            value={data.firstName}
            onChange={(e) => onChange("firstName", e.target.value)}
            className="input-elegant"
            data-error={`delivery_firstName_${index}`}
            isInvalid={!!validationErrors[`delivery_firstName_${index}`]}
          />
          <Form.Control.Feedback type="invalid">
            {validationErrors[`delivery_firstName_${index}`]}
          </Form.Control.Feedback>
        </Col>
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">
            {t("last_name")} *
          </Form.Label>
          <Form.Control
            type="text"
            value={data.lastName}
            onChange={(e) => onChange("lastName", e.target.value)}
            className="input-elegant"
            data-error={`delivery_lastName_${index}`}
            isInvalid={!!validationErrors[`delivery_lastName_${index}`]}
          />
          <Form.Control.Feedback type="invalid">
            {validationErrors[`delivery_lastName_${index}`]}
          </Form.Control.Feedback>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">
            {t("street_house")} *
          </Form.Label>
          <Form.Control
            type="text"
            value={data.street}
            onChange={(e) => onChange("street", e.target.value)}
            className="input-elegant"
            data-error={`delivery_street_${index}`}
            isInvalid={!!validationErrors[`delivery_street_${index}`]}
          />
          <Form.Control.Feedback type="invalid">
            {validationErrors[`delivery_street_${index}`]}
          </Form.Control.Feedback>
        </Col>
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">
            {t("address_extra_label")}
          </Form.Label>
          <Form.Control
            type="text"
            value={data.addressExtra}
            onChange={(e) => onChange("addressExtra", e.target.value)}
            className="input-elegant"
          />
        </Col>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold with-icon">
          {t("postal_city")}
        </Form.Label>
        <LocationAutocomplete
          disabled
          type="text"
          name="postalCity"
          value={data.postalCity || previousDeliveryAddress}
          onChange={handleLocationChange}
          className="input-elegant"
          data-error={`delivery_postalCity_${index}`}
          isInvalid={!!validationErrors[`delivery_postalCity_${index}`]}
        />
        <Form.Control.Feedback type="invalid">
          {validationErrors[`delivery_postalCity_${index}`]}
        </Form.Control.Feedback>
        {previousDeliveryAddress && !data.postalCity && (
          <Form.Text className="text-muted">
            {t("previous_selection_used", { address: previousDeliveryAddress })}
          </Form.Text>
        )}
      </Form.Group>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">
            {t("phone_number")}
          </Form.Label>
          <Form.Control
            type="text"
            value={data.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            className="input-elegant"
          />
        </Col>
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">
            {t("reference_number")}
          </Form.Label>
          <Form.Control
            type="text"
            value={data.deliveryReference}
            onChange={(e) => onChange("deliveryReference", e.target.value)}
            className="input-elegant"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Label className="fw-bold with-icon">{t("date")}</Form.Label>
          <Form.Control
            type="date"
            value={data.deliveryDate}
            onChange={handleDateChange}
            className="input-elegant"
            data-error={`delivery_date_${index}`}
            isInvalid={!!validationErrors[`delivery_date_${index}`]}
            min={minDate}
          />
          <Form.Control.Feedback type="invalid">
            {validationErrors[`delivery_date_${index}`]}
          </Form.Control.Feedback>
        </Col>
        <Col md={3}>
          <Form.Label className="fw-bold with-icon">{t("from")}</Form.Label>
          <TimeSelect
            value={data.timeFrom}
            onChange={(val) => handleTimeFromChange({ target: { value: val } })}
            error={validationErrors[`delivery_timeFrom_${index}`]}
            // minTime={data.deliveryDate === minDate ? minTime : "07:00"}
            // maxTime="18:00"
          />
          {validationErrors[`delivery_timeFrom_${index}`] && (
            <div className="invalid-feedback d-block">
              {validationErrors[`delivery_timeFrom_${index}`]}
            </div>
          )}
        </Col>
        <Col md={3}>
          <Form.Label className="fw-bold with-icon">{t("to")}</Form.Label>
          <TimeSelect
            value={data.timeTo}
            onChange={(val) => onChange("timeTo", val)}
            error={validationErrors[`delivery_timeTo_${index}`]}
            // minTime={data.deliveryDate === minDate ? minTime : "07:00"}
            // maxTime="18:00"
          />
          {validationErrors[`delivery_timeTo_${index}`] && (
            <div className="invalid-feedback d-block">
              {validationErrors[`delivery_timeTo_${index}`]}
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}

export default function StepThree({
  forms = [],
  setForms,
  validationErrors = {},
  pickupForms,
  durationText,
}) {
  const location = useLocation();
  const { state } = location;
  const { bookingData, orderFormData } = state || {};
  const { t } = useTranslation();

  useEffect(() => {
    if (!setForms) return;

    if (
      forms.length > 0 &&
      forms.some((f) => f.firstName || f.lastName || f.street)
    ) {
      return;
    }

    const previousDeliveryAddresses = state?.formData?.zustellung || [];

    if (previousDeliveryAddresses.length > 0) {
      const initialForms = previousDeliveryAddresses.map(
        (addressObj, index) => {
          const address =
            typeof addressObj === "string" ? addressObj : addressObj?.address;
          return {
            ...emptyDelivery(),
            postalCity: address || "",
            postalCity_lat: addressObj?.lat || "",
            postalCity_lng: addressObj?.lng || "",
          };
        },
      );
      setForms(initialForms);
    } else {
      setForms([emptyDelivery()]);
    }
  }, [setForms, state]);

  const handleChange = (index, field, value) => {
    if (!setForms) return;
    // Ensure postalCity is always a string
    const processedValue = field === 'postalCity' ? String(value || '') : value;
    setForms((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: processedValue } : item)),
    );
  };

  const addForm = () => {
    if (!setForms) return;
    setForms((prev) => [...prev, emptyDelivery()]);
  };

  const removeForm = (index) => {
    if (!setForms) return;
    setForms((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      {forms.map((formData, idx) => (
        <Card key={idx} className="mb-4 p-3 border-0" style={{ borderRadius: "16px", backgroundColor: "#ffffff", border: "1px solid #e2e8f0" }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="m-0 text-dark fw-bold">
              {t("delivery_address_label")} {idx + 1}
            </h5>
            {forms.length > 1 && (
              <Button
                variant="outline-danger"
                size="sm"
                className="p-1 px-2"
                style={{ backgroundColor: "#fef2f2", borderColor: "#fee2e2", color: "#ef4444", borderRadius: "8px" }}
                onClick={() => removeForm(idx)}
              >
                <FaTrash />
              </Button>
            )}
          </div>

          <AddressFormDelivery
            data={formData}
            onChange={(field, value) => handleChange(idx, field, value)}
            index={idx}
            validationErrors={validationErrors}
            pickupForms={pickupForms}
            durationText={durationText}
          />
        </Card>
      ))}

      <div className="d-flex justify-content-end align-items-center mb-3">
        <Button
          variant="outline-warning"
          size="sm"
          className="fw-bold px-3 py-1 d-flex align-items-center"
          style={{ borderColor: "#ff6b00", color: "#ff6b00", borderRadius: "8px", backgroundColor: "#ffffff" }}
          onClick={addForm}
        >
          <FaPlus className="me-1" /> {t("add_address")}
        </Button>
      </div>
    </>
  );
}
